import { Provider } from 'react-redux';
import { useRef, type ReactNode } from 'react';

import { store } from './store';
import { AppStore } from './types';

type Props = {
  children: ReactNode;
};

export function StoreProvider({ children }: Props) {
  const storeRef = useRef<AppStore>();

  if (!storeRef.current) {
    storeRef.current = store;
  }

  return <Provider store={storeRef.current}>{children}</Provider>;
}
